import React, { useState } from "react";
import Slider from "react-slick";
import { _feedback_slideshow } from "../../constants/feedback_slideshow";

// Custom Next Arrow
function NextArrow(props) {
  const { onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        position: "absolute",
        top: "50%",
        right: "-2rem",
        transform: "translateY(-50%)",
        zIndex: 2,
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        outline: "none",
      }}
    >
      <i className="fas fa-arrow-right" style={{ fontSize: "16px", color: "#fff" }} />
    </button>
  );
}

// Custom Prev Arrow
function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        position: "absolute",
        top: "50%",
        left: "-2rem",
        transform: "translateY(-50%)",
        zIndex: 2,
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        outline: "none",
      }}
    >
      <i className="fas fa-arrow-left" style={{ fontSize: "16px", color: "#fff" }} />
    </button>
  );
}

function FeedbackSlideshow() {
  // Track the active slide for customPaging
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    slidesToShow: 3,
    infinite: true,
    autoplay: false,
    // On desktop, no dots; custom arrows are shown
    dots: false,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    // Keep track of the current slide index
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    // For the custom dot styling
    dotsClass: "slick-dots custom-dots",
    appendDots: (dots) => (
      <ul
        key={currentSlide}
        style={{
          margin: 0,
          padding: 0,
          position: "absolute",
          bottom: "-40px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          listStyle: "none",
        }}
      >
        {dots}
      </ul>
    ),
    customPaging: (i) => {
      const isActive = i === currentSlide;
      return (
        <div
          style={{
            width: "15px",
            height: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              width: isActive ? "15px" : "10px",
              height: isActive ? "15px" : "10px",
              border: "1px solid black",
              borderRadius: "50%",
              backgroundColor: isActive ? "transparent" : "black",
              transition: "all 0.3s ease",
            }}
          ></span>
        </div>
      );
    },
    responsive: [
      {
        // Tablet: 2 slides, hide arrows, show custom dots
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        // Mobile: 1 slide, hide arrows, show custom dots
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <section className="py-12 py-lg-15">
      <div className="container">
        <h2 className="mb-10 text-center fs-30 fs-md-40">Zufriedene Kunden</h2>
        <Slider {...settings} style={{ position: "relative" }}>
          {_feedback_slideshow.map((item, index) => (
            <div className="box" data-animate="fadeInUp" key={index}>
              <div className="card border-0">
                <div className="card-body px-3 py-0 text-center">
                  {/* 5-Star Rating */}
                  <ul className="list-inline mb-4">
                    {[...Array(5)].map((_, i) => (
                      <li
                        className="list-inline-item fs-14 text-primary mr-0"
                        key={i}
                      >
                        <i className="fas fa-star"></i>
                      </li>
                    ))}
                  </ul>
                  {/* Testimonial */}
                  <p className="card-text mb-4 font-weight-500">{item.quote}</p>
                  <p className="card-text text-muted fs-13 text-uppercase letter-spacing-05 font-weight-500">
                    {item.product}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default FeedbackSlideshow;